import { ClientError } from './client-error';

export class GraphDataInitializationError extends ClientError {
  constructor(message: string) {
    super(message);

    this.name = 'GraphDataInitializationError';
  }
}
